import { DATA_COLORS, DISABLED_DATA_COLORS } from '../../config/theme/theme';
import { t } from 'i18next';

export const getDisabledSectorColor = (index: number) => {
  return DISABLED_DATA_COLORS[index % DISABLED_DATA_COLORS.length];
};

export const getSectorColor = (index: number) => {
  return DATA_COLORS[index % DATA_COLORS.length];
};

export const getHelpTextMap = (): Map<string, string> => {
  return new Map<string, string>([
    ['Symmetric Keys', t('helpTexts.symmetricKeys')],
    ['Asymmetric Keys', t('helpTexts.asymmetricKeys')],
  ]);
};
